import { AutopilotSidebar as BaseAutopilotSidebar } from 'screens/VirtualMarketerOnboarding/AutopilotSidebar/AutopilotSidebar'
import Styles from '../BrandPlanCurrentVolumeV2/BrandPlanCurrentVolumeV2.module.scss'
import { useExperiment } from 'utils/experiments'

export const AutopilotSidebar = () => {
  const integrationsOnboardingVariant = useExperiment('integrations_onboarding')

  if (integrationsOnboardingVariant === 'v2') {
    return (
      <BaseAutopilotSidebar
        sections={[
          {
            heading: 'Why Integrate?',
            text: (
              <div>
                <ul className={Styles.sidebarUl}>
                  <li className={Styles.sidebarLi}>AI generated insights to get better traffic</li>
                  <li className={Styles.sidebarLi}>
                    Save 5+ hours per week through automatic posting. All posts auto-schedule by default—review, edit,
                    or delete anytime.
                  </li>
                </ul>
              </div>
            ),
          },
          {
            heading: 'Connection issues?',
            text: 'Our support team resolves 95% of issues in under 3 minutes via the help button below.',
          },
        ]}
      />
    )
  }

  return (
    <BaseAutopilotSidebar
      sections={[
        {
          heading: 'Say goodbye to copy/paste',
          text: 'Connect your accounts and save 5+ hours per week through automatic posting.',
        },
        {
          heading: 'Connection issues?',
          text: 'Our support team resolves 95% of issues in under 3 minutes via the help button below.',
        },
      ]}
    />
  )
}
